import '../account/Drones.css';
import './Console.css';
import { useState, useEffect, useCallback, useRef, ReactNode } from 'react'
import { logger } from '../../utils/logger'
import { Button, Offcanvas, Modal } from "react-bootstrap";
import ConsoleBindCard from './ConsoleBindCard';
import ConsoleNavMenu from './ConsoleNavMenu';
import ModemCard from './ModemCard';
import ConsoleBind from './ConsoleBind';
import ConsoleMap from './ConsoleMap';
import NavigationData from './NavigationData';
import ModemSettings from './ModemSettings'
import WebRtc from './webRtc/WebRtc';
import AstraWelcome from './astra/AstraWelcome'
import Fpv from './fpv/Fpv';
import FpvModeButton from './fpv/FpvModeButton';
import SubscriptionNotification from './astra/SubscriptionNotification';
import useDroneHubConnection from '../../hooks/DroneHubConnection';
import { HubHbStatusMessage, HubSetOnlineMessage } from '../../asp/DroneHub';
import { ModemData, MultipleModemsSchema, StartMessageData } from '../../api/Drone';
import { AstraSubscriptionDataList, AstraSubscriptionListSchema } from '../../api/AstraSubscription';
import { APIRequestGet } from '../../utils/APIRequests';

type ImeiMap = { [key: string]: HTMLDivElement };

function Console(): ReactNode {
    const droneHub = useDroneHubConnection();
    const [updateOnlineDroneFromHub, setUpdateDroneFromHub] = useState<HubSetOnlineMessage | null>(null);
    const [updateHbFromHub, setUpdateHbFromHub] = useState<HubHbStatusMessage | null>(null);

    const [mode, setMode] = useState<string>("normal");
    const [drones, setDrones] = useState<ModemData[]>([]);
    const [drone, setDrone] = useState<ModemData | null>(null);
    const [mapFocusOnDrone, setMapFocusOnDrone] = useState<boolean>(false);
    const [_isConfirmEmail, setIsConfirmEmail] = useState<boolean>(false);
    const [isNebosvodAuth, setIsNebosvodAuth] = useState<boolean>(false);
    const [nebosvodAuthLogin, setNebosvodLogin] = useState<string>("");
    const [startMsgs, setStartMsgs] = useState<StartMessageData[]>([]);

    const [isLoad, setIsLoad] = useState<boolean>(false);
    const [isBind, setIsBind] = useState<boolean>(false);
    const [modemCardOnlineTop, setModemCardOnlineTop] = useState<boolean>(false);

    const [showMenu, setShowMenu] = useState<boolean>(false);

    const [showFpvModal, setShowFpvModel] = useState<boolean>(false);
    const [subscriptions, setSubscriptions] = useState<AstraSubscriptionDataList>([]);

    const modemCardRefs = useRef<ImeiMap>({});

    const isAstra = process.env.REACT_APP_SERVICE === 'astra';

    const handleCloseMenu = useCallback((): void => {
        setShowMenu(false);
    }, []);

    const toggleShowMenu = useCallback((): void => {
        setShowMenu((s) => !s);
    }, []);

    // const consoleNavMsgClick = useCallback((): void => {
    //     setShowMsgs((s) => !s);
    // }, []);

    useEffect(() => {
        logger.info("console mount");
        getDronesInfo();
        getSubscriptions();
    }, []);

    useEffect(() => {
        if (updateOnlineDroneFromHub != null) {
            const ddd = drones.map(d => {
                const temp = Object.assign({}, d);
                if (updateOnlineDroneFromHub.imei === temp.imei) {
                    temp.isOnline = updateOnlineDroneFromHub.isOnline
                }
                return temp;
            });
            setDrones(ddd);
        }
    }, [updateOnlineDroneFromHub]);

    useEffect(() => {
        if (Array.isArray(drones) && drones.length > 8) {
            setModemCardOnlineTop(true);
        }
    }, [drones]);

    useEffect(() => {
        if (updateHbFromHub != null) {
            let update = false;
            const ddd = drones.map(d => {
                const temp = Object.assign({}, d);
                if (updateHbFromHub.imei === temp.imei) {
                    if (updateHbFromHub.isArm !== temp.isArm) {
                        //todo: refresh only arm
                        update = true;
                    }
                    temp.isArm = updateHbFromHub.isArm;
                    temp.mode = updateHbFromHub.mode;
                }
                /*if(drone?.imei === temp.imei) {
                    setDrone(temp);
                    logger.info('Set drone tmp:')
                    logger.info(temp);
                }*/
                return temp;
            });
            //logger.info(ddd);
            if (update) {
                setDrones(ddd);
            }
        }
    }, [updateHbFromHub]);

    useEffect(() => {
        droneHub.connection.on('SetOnline', (message) => {
            //logger.info("hub: SetOnline"); 
            setUpdateDroneFromHub(message);
        });

        droneHub.connection.on('HbStatus', (message) => {
            //logger.info("hub: HbStatus");
            setUpdateHbFromHub(message);
        });
    }, [droneHub]);

    // Возвращает true, если модем selectImei есть в списке и выбран.
    function getDronesInfo(selectImei?: string): Promise<boolean> {
        return APIRequestGet(`/drone/getModems`, {
            schema: MultipleModemsSchema,
            logSuccess: true
        }).then((result) => {
            setDrones(result.data.modemsInfo);
            setIsConfirmEmail(result.data.isConfirmEmail);
            setIsNebosvodAuth(result.data.isNebosvodAuth);
            setNebosvodLogin(result.data.nebosvodLogin);
            setStartMsgs(result.data.startMsgs);
            setIsLoad(true);
            if (selectImei) {
                const bound = result.data.modemsInfo.find(d => d.imei === selectImei);
                if (bound) {
                    setIsBind(false);
                    setDrone(bound);
                    return true;
                }
            }
            return false;
        }).catch((error) => {
            // 401 разбирает интерцептор axiosInstance, он же и редиректит.
            logger.info(error);
            return false;
        });
    }

    function getSubscriptions(): void {
        APIRequestGet(`/astraSubscription/getSubscriptions`, {
            schema: AstraSubscriptionListSchema,
            logSuccess: true
        }).then((result) => {
            setSubscriptions(result.data);
        });
    }

    const nebosvodLogin = useCallback((nebosvodLogin: string): void => {
        setIsNebosvodAuth(true)
        setNebosvodLogin(nebosvodLogin)
        logger.info("nebosvod login: " + nebosvodLogin)
    }, []);

    // Модем привязан: перечитываем список и выбираем новое устройство,
    // без window.location.reload().
    const bindIsOk = useCallback((imei: string): Promise<boolean> => {
        logger.info("bind is ok, refresh modems: " + imei);
        return getDronesInfo(imei);
    }, []);

    const modemCardClick = useCallback((imei: string): void => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
            setIsBind(false);
            setDrone(selected);
            setMapFocusOnDrone(true);
        }
    }, [drones]);

    const markerClick = useCallback((imei: string): void => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
            setIsBind(false);
            setDrone(selected);
            scrollToModemCard(imei);
        }
    }, [drones]);

    const scrollToModemCard = (imei: string): void => {
        const el = modemCardRefs.current[imei];
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    // const callback = (id, phase, actualTime, baseTime, startTime, commitTime) => {
    //     logger.info(`${id}'s ${phase} phase: Actual: ${actualTime} ms`);
    // }

    const unselectModem = (): void => {
        setDrone(null);
        setMode("normal");
    }

    function isModemSettingsReady(drone: ModemData | null): drone is ModemData {
        return isLoad && !(isBind || (drone == null || drone.imei == null));
    }

    const onCloseFpvMode = (): void => {
        setMode("normal");
    }

    const getDronesOrdered = (): ModemData[] => {
        if (modemCardOnlineTop) {
            return drones.sort((x, y) => x.name.localeCompare(y.name, "pl")).sort(x => x.isOnline ? -1 : 1);
        }
        return drones;
    }

    return (
        <div className={'console-page' + (drone ? " drone-selected" : "")}>
            {drone == null ? (
                <ConsoleNavMenu />
            ) : (
                <ConsoleNavMenu
                    drone={drone}
                    unselectModem={unselectModem}
                    toggleShowMenu={toggleShowMenu}
                    startMsgs={startMsgs}
                />
            )}
            <SubscriptionNotification subscriptions={subscriptions} />
            {mode === "fpv" && drone &&
                <Fpv drone={drone} onClose={onCloseFpvMode} />
            }
            <div className='console-container'>
                <ConsoleMap currentDrone={drone} updateFocus={mapFocusOnDrone} markerClick={markerClick} />
                <div className='console-layout'>
                    {mode !== "fpv" &&
                        <div className={'console-modem-cards' + (isModemSettingsReady(drone) ? ' modem-selected' : '')}>
                            {/*drones.length > 4 ? <SortCard onlineTopClick={() => { onlineTopClick() }} /> : <></>*/}
                            {getDronesOrdered().map(d =>
                                <div
                                    className='console-modem-card-wrap'
                                    key={d.imei}
                                    ref={(el) => { if (el) modemCardRefs.current[d.imei] = el }}
                                >
                                    <ModemCard
                                        imei={d.imei}
                                        modemName={d.name}
                                        isOnline={d.isOnline}
                                        isActive={drone?.imei === d.imei}
                                        version={d.version}
                                        update={d.isLastFirmware}
                                        upgrade={d.upgradable}
                                        isArm={d.isArm}
                                        mavType={d.mavType}
                                        onClick={modemCardClick}
                                    />
                                </div>
                            )}
                            {!isAstra &&
                                <ConsoleBindCard
                                    onClick={() => {
                                        setIsBind(true);
                                        setDrone(null);
                                    }}
                                />
                            }
                        </div>
                    }

                    {mode !== "fpv" && isModemSettingsReady(drone) &&
                        <>
                            <WebRtc drone={drone} mode={mode} />
                            <div className="console-layout-right">
                                <NavigationData drone={drone} />
                                <FpvModeButton onClick={() => { setShowFpvModel(true) }} />
                                <Modal show={showFpvModal} onHide={() => { setShowFpvModel(false) }}>
                                    <Modal.Header closeButton>
                                        <Modal.Title style={{ color: "#000000" }}>Осторожно</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ color: "#000000" }}>
                                        При переходе в FPV режим, вы перехватите управление, если уже кто-то подключен через Astra
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => { setShowFpvModel(false) }}>
                                            Закрыть
                                        </Button>
                                        <Button variant="primary" onClick={() => { setMode('fpv'); setShowFpvModel(false); }}>
                                            Продолжить
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </>
                    }

                    {isLoad && (isBind || (drone == null || drone.imei == null)) &&
                        <>
                            {isAstra ? (
                                <AstraWelcome droneCount={drones.length} />
                            ) : (
                                <ConsoleBind onBindOk={bindIsOk} />
                            )}
                        </>
                    }
                </div>
            </div>
            {isLoad && !(isBind || (drone == null || drone.imei == null)) &&
                <Offcanvas show={showMenu} onHide={handleCloseMenu} name="test name" placement='end'>
                    <Offcanvas.Body>
                        <div className="offcanvas-close-btn" onClick={handleCloseMenu}></div>
                        <ModemSettings drone={drone} isNebosvodAuth={isNebosvodAuth} nebosvodAuthLogin={nebosvodAuthLogin} onNebosvodAuth={nebosvodLogin} isAstra={isAstra} />
                    </Offcanvas.Body>
                </Offcanvas>
            }
        </div>
    )
}

export default Console;